import React, { Component, Fragment } from 'react';
import { Helmet } from 'react-helmet';
import { injectIntl } from 'react-intl';
import { connect } from 'redux-zero/react';
import NotImplemented from '../../components/not-implemented/not-implemented.js';
import About from '../../components/tta-page/about.js';
import OurMission from '../../components/tta-page/our-mission.js';
import OurValues from '../../components/tta-page/our-values.js';
import Board from '../../components/tta-page/board.js';
import Units from '../../components/tta-page/units.js';
import { withLocaleContext } from '../../locales/locale-context.js';
import { actions } from '../../shared/store.js';
import './tta.scss';
import TechnologyTransferAssociationService from './tta.service.js';

class TechnologyTransferAssociationPage extends Component {
	static prefetchData = async language =>
		TechnologyTransferAssociationService.getTechnologyTransferAssociationData(
			language
		);

	state = {
		hasError: false
	};

	componentDidMount() {
		const { ttaPageData, setLoading } = this.props;
		if (!ttaPageData) {
			this.fetchData();
		} else {
			setLoading(false);
		}
	}

	componentDidUpdate(prevProps) {
		const {
			localeContext: { locale }
		} = this.props;

		if (prevProps.localeContext.locale.value !== locale.value) {
			this.fetchData();
		}
	}

	fetchData() {
		const {
			setLoading,
			setTtaPageData,
			localeContext: { locale }
		} = this.props;

		setLoading(true);

		TechnologyTransferAssociationPage.prefetchData(locale.value)
			.then(data => {
				setTtaPageData(data);
				setLoading(false);
			})
			.catch(() => {
				setLoading(false);
				this.setState({
					hasError: true
				});
			});
	}

	render() {
		const { hasError } = this.state;
		const { isLoading, ttaPageData } = this.props;

		if (isLoading) return null;

		if (hasError || !ttaPageData) {
			return <NotImplemented />;
		}

		const { title, about, mission, values, board, units } = ttaPageData;

		return (
			<Fragment>
				<Helmet>
					<title>{title}</title>
				</Helmet>
				<div id="tta-page">
					<About data={about} />
					<OurMission data={mission} />
					<OurValues data={values} />
					<Board data={board} />
					<Units data={units} />
				</div>
			</Fragment>
		);
	}
}

const mapToProps = ({ ttaPageData }) => ({ ttaPageData });

export default withLocaleContext(
	injectIntl(connect(mapToProps, actions)(TechnologyTransferAssociationPage))
);

export { TechnologyTransferAssociationPage };
